export default "__VITE_ASSET__w6Sx6X8W__"